import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

const KEY = "pft_install_dismissed";
const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export function clearOfflineData() {
  navigator.serviceWorker?.controller?.postMessage({ type: "clear" });
}

export function InstallBanner() {
  const [evt, setEvt] = useState(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (standalone() || localStorage.getItem(KEY)) return undefined;
    const onPrompt = (e) => { e.preventDefault(); setEvt(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIOS()) setShow(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);
  if (!show) return null;
  const close = () => { localStorage.setItem(KEY, "1"); setShow(false); };
  const install = async () => { evt.prompt(); await evt.userChoice; close(); };
  return (
    <div className="md:hidden flex items-start gap-3 border border-[#c1ff72]/40 bg-[#c1ff72]/[0.06] p-4 mb-6" data-testid="install-banner">
      <img src="/training-icon-192.png" alt="" className="w-11 h-11 shrink-0" />
      <div className="flex-1 text-sm">
        <p className="text-white font-semibold">App auf dem Handy installieren</p>
        {evt ? <p className="text-[#A1A1AA] mt-1">Mit eigenem Symbol auf dem Startbildschirm – startet im Vollbild wie eine normale App.</p>
          : <p className="text-[#A1A1AA] mt-1">In Safari unten auf <Share className="inline w-4 h-4 -mt-1" /> „Teilen“ tippen, dann „Zum Home-Bildschirm“.</p>}
        {evt && <button onClick={install} className="mt-3 h-10 px-4 bg-[#c1ff72] text-black font-bold flex items-center gap-2" data-testid="install-button"><Download className="w-4 h-4" />Installieren</button>}
      </div>
      <button onClick={close} aria-label="Schließen" className="text-[#71717A] p-1" data-testid="install-dismiss"><X className="w-5 h-5" /></button>
    </div>
  );
}
